import React,{useEffect,useState,useMemo } from 'react';
import {currentDateFormat} from "../utils";
import OfficeAdminTable from '../components/tables/OfficeAdminTable';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import { GET_OFFICE_ADMIN_URL } from '../constant'; 
import axios from 'axios';

const OfficeAdminList = () => {
    const [currentDate,setCurrentDate] = useState(new Date());
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loader.loading);
    const [filteredScheduleList, setFilteredScheduleList] = useState([]);

    useEffect(()=>{
      dispatch(setLoading(true));
        axios.get(GET_OFFICE_ADMIN_URL)
        .then(response => {
          dispatch(setLoading(false));
           console.log("DRIVER",response.data);
           //setDriverDetails(response.data);
           setFilteredScheduleList(response.data)
         })
        .catch(error => {
           console.error(error);
         });

    },[]);
    return(
        <>
        <div>
       <section>
       
       <div className='d-flex justify-content-between form-container'>
             <div>
               <h2 className="fs-5 font-weight-600">Office Admin List  </h2>
             </div>
             <div>
               <span >{currentDateFormat(currentDate)}</span>
             </div>
           </div>
   </section>
   <section>
        <div>
        <OfficeAdminTable tableData={filteredScheduleList} />        
        </div>
</section>
  
   
   </div>
   </>
    );
}

export default OfficeAdminList;